<template>
    <b-container fluid>
        <div v-if="wizardData" class="mb-3">
            <div class="d-flex justify-content-between align-items-center pt-3">
                <div>
                    <b>{{ wizardData.name }} - Amenities</b>
                </div>
                <responsive-button
                    size="sm"
                    withSpace
                    :icon="['fas', 'copy']"
                    variant="default"
                    @click="$bvModal.show(copyAmenitiesModalId)"
                    >Copy Amenities</responsive-button
                >
            </div>
            <hr />
        </div>
        <div v-if="amenities">
            <div v-for="(key, index) in Object.keys(amenities)" :key="key" class="mb-md-5 mb-3">
                <div class="toggle-accordion-button" v-b-toggle="'accordion-' + index">
                    <div class="d-flex align-items-center">
                        <b class="d-block"
                            >{{ key }}
                            <span
                                v-if="
                                    key == 'Cleaning or safety practice' ||
                                    key == 'Flexcation' ||
                                    key == 'Regional standard for sanitation practice'
                                "
                            >
                                (VRBO Only)</span
                            ></b
                        >
                        <span class="when-open ml-1"><font-awesome-icon :icon="['fas', 'circle-minus']" /></span>
                        <span class="when-closed ml-1"><font-awesome-icon :icon="['fas', 'circle-plus']" /></span>
                    </div>
                    <hr />
                </div>
                <b-collapse visible :id="'accordion-' + index">
                    <b-row class="flex-wrap">
                        <b-col md="4" v-for="amenity in amenities[key]" :key="amenity.id">
                            <form-checkbox
                                class="mb-0"
                                @change="(val) => setAmenity(val, amenity.id)"
                                v-model="amenity.checked"
                                >{{ amenity.name }}</form-checkbox
                            >
                        </b-col>
                    </b-row>
                </b-collapse>
            </div>
        </div>
        <modal
            :id="copyAmenitiesModalId"
            title="Copy Amenities
"
            :ok-disabled="!selectedSource"
            ok-title="Copy"
            @ok.prevent="copyAmenities"
        >
            <form-select
                v-if="initialData"
                floatingLabel="From Property"
                v-model="selectedSource"
                :options="propertyChoices"
            />
            <small class="text-danger"> All amenities will be replaced. Do you want to proceed? </small>
        </modal>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../../../api';
import { RENTAL_PROPERTY_SETUP_AMENITIES_ENDPOINT } from '../../../../endpoints';
import { formatResponseError } from '../../../../utils/api';
import ResponsiveButton from '../../../generic/responsive-button/responsive-button.vue';
import FormCheckbox from '../../../generic/form-checkbox/form-checkbox.vue';
import Modal from '../../../generic/modal/modal.vue';
import FormSelect from '../../../generic/form-select/form-select.vue';

export default {
    name: 'Amenities',
    components: {
        ResponsiveButton,
        FormCheckbox,
        Modal,
        FormSelect,
    },
    inject: ['propertyId'],
    data() {
        return {
            amenities: null,
            copyAmenitiesModalId: 'copy-amenities-modal-id',
            selectedSource: null,
        };
    },
    mounted() {
        this.fetchAmenities();
    },
    computed: {
        ...mapGetters('setupPropertyStore', ['wizardData', 'initialData', 'propertyChoices']),
    },
    methods: {
        async fetchAmenities() {
            try {
                this.$parent.$emit('busy', true);
                const { data } = await api.get(RENTAL_PROPERTY_SETUP_AMENITIES_ENDPOINT(this.propertyId));
                this.amenities = data;
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not fetch amenities',
                });
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
        async setAmenity(value, id) {
            try {
                const { data } = await api.post(
                    `${RENTAL_PROPERTY_SETUP_AMENITIES_ENDPOINT(this.propertyId)}set-amenity/`,
                    {
                        id,
                        checked: value,
                    }
                );
                this.amenities = data;
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not set amenity',
                });
            }
        },
        async copyAmenities() {
            try {
                await api.post(`${RENTAL_PROPERTY_SETUP_AMENITIES_ENDPOINT(this.propertyId)}copy-amenities/`, {
                    source_pk: this.selectedSource,
                });
                await this.fetchAmenities();
                this.selectedSource = null;
                this.$bvModal.hide(this.copyAmenitiesModalId);
                this.successToast({ text: 'Amenities successfully copied.' });
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not copy amenities',
                });
            }
        },
    },
    watch: {
        amenities(newVal, oldVal) {
            const isEquals = JSON.stringify(newVal) === JSON.stringify(oldVal);
            if (!isEquals) {
                this.amenities = JSON.parse(JSON.stringify(newVal));
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.toggle-accordion-button {
    cursor: pointer;
    :hover {
        color: #0d47a1;
    }
    .when-open {
        display: block;
    }
    .when-closed {
        display: none;
    }
}
:deep(.toggle-accordion-button.collapsed) {
    .when-closed {
        display: block;
    }
    .when-open {
        display: none;
    }
}
</style>